/**
 * Since cameras have different traits that the presentation interface doesn't know about it (horizontal and vertical values),
 * this consolidates what those values should be represented as in the ui.
 * @param {String} key - They key that is sent with the action
 * @return {String}
 */

export default function consolidatePresentationKey(key) {
  switch (key) {
    case 'horizontalAngleOfView':
    case 'verticalAngleOfView':
      return 'angleOfView'
    case 'horizontalFieldOfView':
    case 'verticalFieldOfView':
      return 'fieldOfView'
    default:
      return key
  }
}



// WEBPACK FOOTER //
// ./src/helpers/presentation/consolidatePresentationKey.js